export const defaultTimezone = 'Europe/Bratislava'
